<template>
  <div class="app-main-content">
    <div class="container-left">
      <div class="container-left-header">
        <div class="tabs">
          <div class="item" :class="{ active: index === curIndex}" @click="tabsChange(index)"
               v-for="(item, index) in ['分配给我的', '我创建的']" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="content" v-if="curIndex === 0">
          <div class="item">
            <img :src="$toUrl('task_status_blue1.png')" alt="">
            <div class="info">
              <div class="status">未开始</div>
              <div class="value">{{ staData.not_start_tome }}</div>
            </div>
          </div>
          <div class="item">
            <img :src="$toUrl('task_status_yellow1.png')" alt="">
            <div class="info">
              <div class="status">进行中</div>
              <div class="value">{{ staData.start_tome }}</div>
            </div>
          </div>
          <div class="item">
            <img :src="$toUrl('task_status_green1.png')" alt="">
            <div class="info">
              <div class="status">已完成</div>
              <div class="value">{{ staData.finish_tome }}</div>
            </div>
          </div>
        </div>
        <div class="content" v-else>
          <div class="item">
            <img :src="$toUrl('task_status_blue1.png')" alt="">
            <div class="info">
              <div class="status">未开始</div>
              <div class="value">{{ staData.not_start_icreated }}</div>
            </div>
          </div>
          <div class="item">
            <img :src="$toUrl('task_status_yellow1.png')" alt="">
            <div class="info">
              <div class="status">进行中</div>
              <div class="value">{{ staData.start_icreated }}</div>
            </div>
          </div>
          <div class="item">
            <img :src="$toUrl('task_status_green1.png')" alt="">
            <div class="info">
              <div class="status">已完成</div>
              <div class="value">{{ staData.finish_icreated }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-left-content">
        <card v-if="curIndex === 0" :tabs="issue_status" :allow="false" v-model="allotQuery.issue_status"
              @change="changeAllotList" body-class="overflow-hidden page-card-body">
          <div class="body-flex">
            <div class="body-left-table">
              <dashboard-table :data-source="allotList" :issues_level="cat.issues_level" :task_status="task_status"
                               @reload="reload" />
              <a-pagination
                  style="text-align: center;margin: 12px 0;"
                  v-model="allotPage.page_index"
                  :page-size="allotPage.page_size"
                  :total="allotPage.total"
                  showSizeChanger
                  :pageSizeOptions="['10', '15', '30', '50']"
                  @change="onAllotChange"
                  @showSizeChange="onAllotShowSizeChange"
              />
            </div>
          </div>
        </card>
        <card v-else :tabs="issue_status" :allow="false" v-model="ICreateQuery.issue_status"
              @change="changeICreateList" body-class="overflow-hidden page-card-body">
          <div class="body-flex">
            <div class="body-left-table">
              <dashboard-table :data-source="ICreateList" :issues_level="cat.issues_level" :task_status="task_status"
                               @reload="reload" />
              <a-pagination
                  style="text-align: center;margin: 12px 0;"
                  v-model="iCreatePage.page_index"
                  :page-size="iCreatePage.page_size"
                  :total="iCreatePage.total"
                  showSizeChanger
                  :pageSizeOptions="['10', '15', '30', '50']"
                  @change="onICreateChange"
                  @showSizeChange="onICreateShowSizeChange"
              />
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="container-right">
      <template v-if="curIndex === 0">
        <a-collapse v-model="forme_active_key" :bordered="false">
          <a-collapse-panel key="1" :header="`今日截止任务（${forme_today_end_datas.length}个）`" :style="customStyle">
            <dashboard-table :data-source="forme_today_end_datas" :issues_level="cat.issues_level"
                             :task_status="task_status" @reload="reload" />
          </a-collapse-panel>
          <a-collapse-panel key="2" :header="`本周截止任务（${forme_week_end_datas.length}个）`" :style="customStyle">
            <dashboard-table :data-source="forme_week_end_datas" :issues_level="cat.issues_level"
                             :task_status="task_status" @reload="reload" />
          </a-collapse-panel>
          <a-collapse-panel key="3" :header="`已经超期任务（${forme_overtime_datas.length}个）`" :style="customStyle">
            <dashboard-table :data-source="forme_overtime_datas" :issues_level="cat.issues_level"
                             :task_status="task_status" @reload="reload" />
          </a-collapse-panel>
        </a-collapse>
      </template>
      <template v-else>
        <a-collapse v-model="icreated_active_key" :bordered="false">
          <a-collapse-panel key="1" :header="`今日截止任务（${icreated_today_end_datas.length}个）`" :style="customStyle">
            <dashboard-table :data-source="icreated_today_end_datas" :issues_level="cat.issues_level"
                             :task_status="task_status" @reload="reload" />
          </a-collapse-panel>
          <a-collapse-panel key="2" :header="`本周截止任务（${icreated_week_end_datas.length}个）`" :style="customStyle">
            <dashboard-table :data-source="icreated_week_end_datas" :issues_level="cat.issues_level"
                             :task_status="task_status" @reload="reload" />
          </a-collapse-panel>
          <a-collapse-panel key="3" :header="`已经超期任务（${icreated_overtime_datas.length}个）`" :style="customStyle">
            <dashboard-table :data-source="icreated_overtime_datas" :issues_level="cat.issues_level"
                             :task_status="task_status" @reload="reload" />
          </a-collapse-panel>
        </a-collapse>
      </template>
    </div>
    <task-modal @reload="reload" ref="taskDetailModal">
      <template #IAccept>
        <div class="content-head-btn" v-if="['0', '10'].includes(selectList.issue_status)">
          <a-button type="primary" @click="IAccept" style="margin-left: 10px">
            我接受
          </a-button>
        </div>
      </template>
      <template #close>
        <div class="content-head-btn" style="margin-left: auto;margin-right: 20px;">
          <a-button type="primary" @click="deleteDetail" style="margin-left: 10px">
            删除
          </a-button>
        </div>
      </template>
    </task-modal>
  </div>
</template>
<script>
import { fetch } from '@/utils/request'
import appsettings from '@/utils/appsettings'
import catMixin from "@/utils/mixins/catMixin";
import TaskModal from "@/components/taskModal.vue";
import edpDatePicker from "@/components/e-form/edp-date-picker.vue";
import { FieldUpdateDb } from "@/utils/FieldUpdate";
import EdpSelect from "@/components/e-form/edp-select.vue";
import DashboardTable from "@/view/workspace/components/dashboard-table.vue";

export default {
  components: { DashboardTable, EdpSelect, edpDatePicker, TaskModal },
  mixins: [catMixin],
  data() {
    return {
      dbs: {
        prjIssue: new FieldUpdateDb("prj", "prj_issue"),
      },
      allotPage: {
        page_size: 10,
        page_index: 1,
        total: 0,
      },
      iCreatePage: {
        page_size: 10,
        page_index: 1,
        total: 0,
      },
      appsettings: appsettings,
      cat: {
        issue_bstatus: [],
        issues_level: [],
      },
      staData: {
        not_start_tome: 0,
        start_tome: 0,
        finish_tome: 0,
        not_start_icreated: 0,
        start_icreated: 0,
        finish_icreated: 0
      },
      allotList: [],
      allotQuery: {
        issue_status: '1'
      },
      ICreateList: [],
      ICreateQuery: {
        issue_status: '1'
      },
      curIndex: 0,
      forme_active_key: ['1', '2', '3'],
      icreated_active_key: ['1', '2', '3'],
      customStyle: 'background: #FFF;font-size: 16px;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      forme_today_end_datas: [],
      forme_week_end_datas: [],
      forme_overtime_datas: [],
      icreated_today_end_datas: [],
      icreated_week_end_datas: [],
      icreated_overtime_datas: [],
      selectList: {},
      detail: {},
      detailOid: "",
      detailType: "",
      task_status: [],
    }
  },
  computed: {
    issue_status() {
      return this.cat.issue_bstatus.filter(e => e.cat_code !== '10').sort((a, b) => {
        if (a.cat_name === '已完成') {
          return 1
        } else if (a.cat_name === '未开始' && b.cat_name !== '已完成') {
          return 1
        } else {
          return -1
        }
      })
    }
  },
  mounted() {
    this.getSta()
    this.getTaskStatus()
    this.getAllotList() // 分配给我的列表
    this.getAllotList2()
    this.getICreateList() // 我创建的列表
    this.getICreateList2()
  },
  methods: {
    reload() {
      this.getAllotList() // 分配给我的列表
      this.getICreateList() // 我创建的列表
    },
    // 获取任务状态
    async getTaskStatus() {
      const res = await fetch('post', '/cpy/cat/issuestatus', {
        temp10: this.detail.project_code ?? '全局'
      })
      this.task_status = res.data.datas
    },
    getSta() {
      fetch('POST', '/prj/issue/sta/forme', {}).then((res) => {
        if (res.status === 0) {
          this.staData = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeAllotList() {
      fetch('POST', '/prj/issue/workitems/tome', { ...this.allotQuery, ...this.allotPage }).then((res) => {
        if (res.status === 0) {
          this.allotList = res.data.datas
          this.allotPage.total = res.data.page.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getAllotList() {
      fetch('POST', '/prj/issue/workitems/tome', { ...this.allotQuery, ...this.allotPage }).then((res) => {
        if (res.status === 0) {
          this.allotPage.total = res.data.page.total
          this.allotList = res.data.datas
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getAllotList2() {
      fetch('POST', '/prj/issue/workitems/tome').then((res) => {
        if (res.status === 0) {
          this.forme_today_end_datas = res.data.today_end_datas
          this.forme_week_end_datas = res.data.week_end_datas
          this.forme_overtime_datas = res.data.overtime_datas
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeICreateList() {
      fetch('POST', '/prj/issue/workitems/icreated', { ...this.ICreateQuery, ...this.iCreatePage }).then((res) => {
        if (res.status === 0) {
          this.ICreateList = res.data.datas
          this.iCreatePage.total = res.data.page.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getICreateList() {
      fetch('POST', '/prj/issue/workitems/icreated', { ...this.ICreateQuery, ...this.iCreatePage }).then((res) => {
        if (res.status === 0) {
          this.iCreatePage.total = res.data.page.total
          this.ICreateList = res.data.datas
          this.icreated_today_end_datas = res.data.today_end_datas
          this.icreated_week_end_datas = res.data.week_end_datas
          this.icreated_overtime_datas = res.data.overtime_datas
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getICreateList2() {
      fetch('POST', '/prj/issue/workitems/icreated').then((res) => {
        if (res.status === 0) {
          this.icreated_today_end_datas = res.data.today_end_datas
          this.icreated_week_end_datas = res.data.week_end_datas
          this.icreated_overtime_datas = res.data.overtime_datas
        } else {
          this.$message.error(res.message)
        }
      })
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            console.log(record.oid)
            this.detailOid = record.oid
            this.detailType = record.issue_type
          }
        }
      }
    },
    tabsChange(index) {
      this.curIndex = index
    },
    openTaskDetailModal(row) {
      this.detailOid = row.oid
      this.selectList = row
      this.getDetail(row.oid)
      this.$refs.taskDetailModal.open(row.oid)
    },
    getDetail(oid) {
      return fetch("post", '/prj/issue/details', {
        oid
      }).then(res => {
        console.log('详情', res)
        this.detail = res.data
      })
    },
    IAccept() {
      fetch("post", "/prj/issue/accept", { oid: this.detailOid }).then(res => {
        if (res.status === 0) {
          this.$message.success("接受成功")
          this.$refs.taskDetailModal.getDetail()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    deleteDetail() {
      this.$confirm({
        title: '确定要删除吗?',
        onOk: () => {
          return fetch("post", "/prj/issue/delete", { oid: this.detailOid }).then(res => {
            if (res.status === 0) {
              this.$message.success("删除成功")
              this.$refs.taskDetailModal.visible = false
            } else {
              this.$message.error(res.message)
            }
          })
        },
        onCancel() {
        },
      });
    },
    onAllotChange(page, pageSize) {
      this.allotPage.page_index = page
      this.allotPage.page_size = pageSize
      this.changeAllotList()
    },
    onAllotShowSizeChange(current, size) {
      this.allotPage.page_index = 1
      this.allotPage.page_size = size
      this.changeAllotList()
    },
    onICreateChange(page, pageSize) {
      this.iCreatePage.page_index = page
      this.iCreatePage.page_size = pageSize
      this.changeICreateList()
    },
    onICreateShowSizeChange(current, size) {
      this.iCreatePage.page_index = 1
      this.iCreatePage.page_size = size
      this.changeICreateList()
    },
  }
}
</script>
<style scoped lang="less">
.app-main-content {
  display: flex;
  padding: 12px 10px;

  .container-left, .container-right {
    width: 942px;
    flex-shrink: 0;

    &.container-left {
      margin-right: 12px;
    }

    .container-left-header {
      height: 163px;
      background: #FFFFFF;
      overflow: hidden;

      .tabs {
        display: flex;
        align-items: center;

        .item {
          font-weight: 500;
          font-size: 18px;
          color: #060606;
          margin: 21px 13px 29px;
          cursor: pointer;

          &.active {
            color: var(--primary-color);
            font-weight: 700;
          }
        }
      }


      .content {
        display: flex;
        justify-content: center;

        .item {
          display: flex;
          align-items: center;
          padding: 0 81px 0 81px;
          box-sizing: border-box;

          &:nth-of-type(1) {
            padding: 0 81px 0 0;
          }

          &:nth-of-type(2) {
            border-left: 2px solid #F4F4F4;
            border-right: 2px solid #F4F4F4;
          }

          &:nth-of-type(3) {
            padding: 0 0 0 81px;
          }

          img {
            width: 55px;
            height: 55px;
            display: block;
            margin-right: 21px;
          }

          .info {
            display: flex;
            flex-direction: column;
            align-items: center;

            .status {
              font-weight: 500;
              font-size: 16px;
              line-height: 16px;
              color: #929292;
            }

            .value {
              font-weight: 700;
              font-size: 42px;
              line-height: 42px;
              color: #4D4D4D;
            }
          }
        }
      }
    }

    .container-left-content {
      width: 942px;
      height: 650px;
      margin-top: 12px;

      /deep/ .edp-card {
        height: 100%;
        box-shadow: none;

        .edp-card-body {
          overflow-y: auto;
          flex: 1;
          display: flex;
          flex-direction: column;

          .body-flex {
            flex: 1;
            display: flex;
            overflow: hidden;
            background-color: #F8F8F8;

            .body-left-table {
              flex: 1;
              height: 100%;
              overflow-y: auto;
              overflow-x: auto;
              background: #FFF;
              flex-shrink: 0;
              padding: 16px 12px 0 12px;


              .icon {
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }
  }

  .container-right {
    overflow-y: auto;

    .icon {
      width: 16px;
      height: 16px;
    }
  }
}

</style>
